import { Box, Flex, styled, StyleSystemProps } from '@withjoy/joykit';

// Named styled components
export const StyledRoot = styled(Box)``;
export const StyledContainer = styled(Box)``;
export const StyledContent = styled(Flex)``;

const containerStyles: StyleSystemProps = {
  flexWrap: 'wrap',
};

export const styles = {
  container: containerStyles,
};
